import React, { useState } from "react";
import { Box, Typography, Table, TableCell, TableHead, TableBody, TableRow, TableContainer, Paper, Button, Grid, Tooltip, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomButton from "components/Button";
import { FaPlus } from "react-icons/fa6";
import { GrView } from "react-icons/gr";

const tableData = [
    {
        id: 1,
        month: "September",
        activity: "3",
    },
    {
        id: 2,
        month: "September",
        activity: "6",
    },
    {
        id: 3,
        month: "October",
        activity: "9",
    },
    {
        id: 4,
        month: "November",
        activity: "5",
    },
    {
        id: 5,
        month: "November",
        activity: "7",
    },
];

function PhysicalProgress() {

    const navigate = useNavigate();

    return (
        <>
            <Grid container>
                <Grid size={12}
                    sx={{
                        borderBottom: "1px solid #ECECEC",
                        backgroundColor: "#F6F8F9",
                        justifyContent: "space-between",
                        display: "flex",
                        px: 2,
                        py: 4,
                    }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography sx={{
                            fontWeight: 700,
                            fontSize: { xs: "24px", sm: "32px", md: "36px" },
                            lineHeight: "48px",
                            color: "#252C32",
                            fontFamily: "Outfit, sans-serif",
                        }}>
                            Monthly Plan
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            mt: { xs: 1, sm: 0 },
                            mb: 2,
                        }}>
                        <CustomButton
                            label="Add Monthly Plan"
                            startIcon={<FaPlus />}
                            color="primary"
                            onClick={() => navigate("/projects/7d9e0306-81f4-4cdc-8752-de441b460997/dpr/monthly-plan/add-plan")}
                            sx={{
                                backgroundColor: "#2563EB",
                                fontFamily: 'Outfit',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '100%',
                                letterSpacing: '0px',
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid size={12} sx={{ backgroundColor: "#fff" }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S. No.</TableCell>
                                    <TableCell>Month</TableCell>
                                    <TableCell>No. of Activities</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow
                                        key={row.id}
                                    >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{row.month}</TableCell>
                                        <TableCell>{row.activity}</TableCell>
                                        <TableCell sx={{ cursor: "pointer" }}>
                                            <Tooltip title="View" arrow>
                                                <IconButton
                                                    onClick={() =>
                                                        navigate("/projects/10b9ff2d-8d78-44c4-96b4-26ba2cc35f13/dpr/monthly-plan/view-plan",
                                                            { state: { month: row.month } }
                                                        )
                                                    }
                                                >
                                                    <GrView size={15} />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    );
}

export default PhysicalProgress;